import { loadOpenCV } from "@opencvjs/web";

let openCVPromise = null;

export function getOpenCV() {
  if (!openCVPromise) {
    openCVPromise = loadOpenCV().catch((error) => {
      openCVPromise = null;

      throw error;
    });
  }

  return openCVPromise;
}
